import { ReactElement, useEffect, useState } from "react";
import { CircularProgress, Paper } from "@mui/material";
import { IIndicator, IIndicatorData, IProperty } from "../../../../types";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import HtmlTooltip from "../../../../components/charts/tooltip";
import { useFetch } from "../../../../system/useFetch";

interface IProps {
  dataContext: IIndicator;
}

interface IInformation {
  title: string;
  a: IProperty | undefined;
  b: IProperty | undefined;
  c: IProperty | undefined;
  d: IProperty | undefined;
}

const tenMinutes = 600000;

const IndicatorA = ({ dataContext }: IProps): ReactElement => {
  const { data } = useFetch<IIndicatorData>({
    module: "system",
    query: "getIndicatorDataContext",
    payload: {
      nodeID: dataContext.nodeID,
      nodeType: dataContext.nodeType,
      nodeIndicatorID: dataContext.nodeIndicatorID }
  }, tenMinutes);
  const [ information, setInformation ] = useState<IInformation | null>(null);

  useEffect(() => {
    if (data) {
      setInformation({
        title: data.title,
        a: data.properties.find(x => x.name === "a"),
        b: data.properties.find(x => x.name === "b"),
        c: data.properties.find(x => x.name === "c"),
        d: data.properties.find(x => x.name === "d")
      });
    }
  }, [data, setInformation]);


  if (!information) {
    return (
      <Paper className="menu-indicator-lg display-flex-row justify-content-center align-items-center"  >
        <CircularProgress className=""/>
      </Paper>
    );
  }

  return(
    <Paper className="menu-indicator-lg display-flex-row p-1" >

      <div className="display-grid flex-grow-1" style={{ gridTemplateRows: "1fr 1fr", gridTemplateColumns: "1fr 1fr" }} >
        <strong style={{ color: "rgba(255, 255, 255, 0.9)", textAlign: "left" }}>{information.title}</strong>

        <HtmlTooltip title={information.b?.title ?? "---"}>
          <strong className="justify-self-end" style={{ color: information.b?.color }}>
            {information.b?.value}
            {information.b?.unit && <sub>{`[${information.b?.unit}]`}</sub>}
          </strong>
        </HtmlTooltip>

        <HtmlTooltip title={information.a?.title ?? "---"}>
          <strong className="flex-grow-1 align-content-center" style={{ color: information.a?.color, textAlign: "left" }}>
            {information.a?.value}
            {information.a?.unit && <sub>{`[${information.a?.unit}]`}</sub>}
          </strong>
        </HtmlTooltip>

        <HtmlTooltip title={information.c?.title ?? "---"}>
          <strong className="justify-self-end" style={{ color: information.c?.color  }}>
            {information.c?.value}
            {information.c?.unit && <sub>{`[${information.c?.unit}]`}</sub>}
          </strong>
        </HtmlTooltip>
      </div>

      <div className="display-flex-row flex-grow-0 m-1 justify-content-center align-items-center">

        {`${information.d?.value}` === "0" &&
        <ArrowDownwardIcon style={{ color: "whitesmoke", background: information.d?.color, verticalAlign: "center" }}/>
        }

        {`${information.d?.value}` === "1" &&
        <ArrowUpwardIcon style={{ color: "whitesmoke", background: information.d?.color, verticalAlign: "center" }}/>
        }

      </div>
    </Paper>
  );
};

export default IndicatorA;
